import {customElement, query, queryAll} from "lit/decorators.js";
import {SearchFacade} from "./searchFacade";
import {resolve} from "../../../container";
import {ScrollableBar} from "../../../page/elements/scrollableBar";
import {html, type TemplateResult} from "lit";
import {ResizeObserverFactory} from "../../../common/observation";
import Styles from "./searchGroupTabs.lit.scss";

@customElement("eop-search-group-tabs")
export class EopSearchGroupTabs extends ScrollableBar {

    public static readonly styles = Styles;

    @query(".content-search-tab-items")
    protected scrollableArea: HTMLElement;
    @queryAll(".content-search-tab-item-content")
    private searchTabs: NodeListOf<HTMLElement>;
    private focusResizeObserver: ResizeObserver;

    protected items(): HTMLElement[] {
        return Array.from(this.searchTabs);
    }

    public constructor(
        private searchFacade: SearchFacade = resolve(SearchFacade),
        resizeObserverFactory: ResizeObserverFactory = resolve(ResizeObserverFactory)
    ) {
        super();
        this.focusResizeObserver = resizeObserverFactory.create(() => this.searchFacade.focus());
    }

    public connectedCallback(): void {
        super.connectedCallback();
        this.focusResizeObserver.observe(this);
    }

    public disconnectedCallback(): void {
        this.focusResizeObserver.disconnect();
        super.disconnectedCallback();
    }

    public render(): TemplateResult {
        return html`
            <div class="content-search-tabs-container">
                <nav class="content-search-tabs">
                    <div class="content-search-tab-items horizontally-scrollable-area"
                         @scroll=${this.toggleScrollButtonVisibility}
                         @touchend=${{handleEvent: () => this.toggleScrollButtonVisibility(), passive: true}}
                    >
                        <div aria-hidden="true">
                            <eop-swipe-hint></eop-swipe-hint>
                        </div>
                        ${this.renderSlots()}
                    </div>
                    ${this.renderScrollLeftButton()}
                    ${this.renderScrollRightButton()}
                </nav>
            </div>
        `;
    }

    private renderSlots(): TemplateResult {
        return html`
            <slot name="content-search-tab-item" class="content-search-tab-item-content"></slot>
        `;
    }
}
